import getValueAndUnit from "../../../utils/get-value-and-unit";
import { G_actions } from "../../../utils/globals/actions";
import setCurrentResolution from "../../../utils/resolutions/set-current-resolution";

/**
 * Set "actions"
 * @param {Map<String, any>} stepFnName
 * @param {String} attribute
 * @param {ActionNamesProps} value
 * @param {String | undefined} original
 * @param {Map<String, any>} global
 * @param {Map<String, any>} local
 */
const setAction = (stepFnName, attribute, value, original, global, local) => {
  const name = /** @type {keyof ActionNameObjectProps} */ (attribute);

  /** Property is action (add, get, toggle,...) */
  const isAction = G_actions.has(name);

  stepFnName.set("is-action", isAction);

  if (isAction && value) {
    const actionOptions = new Map();
    const options = global || local;

    if (options) {
      for (const [name, option] of options) {
        const resolutions = option.get("resolutions");
        const current = resolutions.get("current") || resolutions.get("all");

        actionOptions.set(name, current);
      }
    }

    stepFnName.set("action-parent", name);
    stepFnName.set("action-property", value);
    stepFnName.set("action-fn", G_actions.get(name)?.get(value));
    stepFnName.set("action-original", original || null);
    stepFnName.set("action-options", actionOptions);

    const target = /** @type {StorageItemProps} */ (options?.get("target"));

    if (target) {
      const resolutions = /** @type {ResolutionProps} */ (
        target.get("resolutions")
      );

      setCurrentResolution(resolutions);

      const current = /** @type {String} */ (
        /** @type {unknown} */ (resolutions.get("current"))
      );

      const result = getValueAndUnit(current, target, null);
      const element = result.get("value");

      stepFnName.set("o_target", element);
    }
  }
};

export default setAction;
